import { Tag , Typography } from "antd";
import { useIntl } from "react-intl";

import { ImpactSeverityLevel } from "../enums/ImpactSeverityLevel";
import { ProbabilitySeverityLevel } from "../enums/ProbabilitySeverityLevel";
import { getPrimaryColor, getSecondaryColor, getMessageKey } from "../helpers/severity-level";

interface IProps {
    value: number
    severityLevel: ImpactSeverityLevel | ProbabilitySeverityLevel
}

export const SeverityTag = ({ value, severityLevel }: IProps) => {
  const intl = useIntl();
  const primaryColor = getPrimaryColor(severityLevel);
  const secondaryColor = getSecondaryColor(severityLevel);
  const messageKey = getMessageKey(severityLevel);

  return (
    <>
      <Typography.Text style={{ color: primaryColor }} strong>{value}</Typography.Text>
      {' '}
      <Tag color={secondaryColor} style={{ color: primaryColor, fontWeight: 'bold', border: `1px solid ${primaryColor}` }}>
        {messageKey !== null && intl.formatMessage({ id: `risksAndIssues.severity.${messageKey}` })}
      </Tag>
    </>
  );
};